<template>
    <div id="app-stripe-cart" class="bg-light-gray veu-cart sf-stripe" sf-cart-id="link" :sf-cart-option="cartOption" :sf-cart-utility="cartUtility">
        <estimator :f="f" :f1="f1" :f2="f2" :gas="gas" @cart-option="cartOptionUpdate" @cart-utility="cartUtilityUpdate"/>
    </div>
</template>

<script>
    import estimator from './components/Estimator/Estimator.vue';

    export default {
        name: 'App',

        components: {
            estimator,
        },

        data: function() {
            return {
                cartOption: "Monoraria",
                cartUtility: ""
            }
        },

        props: {
            f: Number,
            f1: Number,
            f2: Number,
            gas: Number,
        },

        mounted() {
            let myId = document.getElementById('app');
            console.log(myId);
        },

        computed: {
            stampId() {
                let myId = document.getElementById('app');
                return console.log(myId);
            }
        },

        methods: {
            cartOptionUpdate: function(value) {
                this.cartOption = value;
            },

            cartUtilityUpdate: function(value) {
                value == "gas" ? this.cartUtility = "GAS" :
                value == "energy" ? this.cartUtility = "LUCE" : 
                value.length == 2 ? this.cartUtility = "LUCE E GAS" : ""
            }
        }
    }
</script>
